/** Creates the resolved Promise with a value. */
const resolve = Promise.resolve.bind(Promise);

/** Creates the rejected Promise with an error. */
const reject = Promise.reject.bind(Promise);

const promises = (
	...promises
) =>
	Promise.allSettled(promises.flat());

export { promises, reject, resolve };
